<template>
  <div class="stt">
    <div class="location fr fs12 tcaa mt10">
      <span class="hm dinline-block vtop"></span>
      <!-- <span class="sn pl20 dinline-block prelative vtop">学院总站</span>
      <span class="sn pl20 dinline-block prelative vtop">专升本自考</span>
      <span class="sn pl20 dinline-block prelative vtop">联系我们</span> -->
      <router-link :to="'/'" class="sn pl20 dinline-block prelative vtop">学院总站
      </router-link>
      <router-link :to="'/cedu/index'" class="sn pl20 dinline-block prelative vtop">专升本自考
      </router-link>
      <span class="sn pl20 dinline-block prelative vtop">联系我们
      </span>
    </div>
    <div class="lh10">
      <img class="vbottom" src="../../../assets/images/tt_01_02.jpg" alt="">
      <span class="vbottom dinline-block fs24 fbold tc17 pb2">联系我们</span>
    </div>
  </div>
</template>

<script>
    export default {
        name: "ttitle"
    }
</script>

<style scoped>
  .location .hm{width: 15px;height: 20px;background: url(../../../assets/images/cn2.png) no-repeat -15px -55px;}
  .location .sn::before{content: '';position: absolute;left: 0;width: 20px;height: 20px;background: url(../../../assets/images/cn2.png) no-repeat -105px -53px;}
  .location .sn:last-child{color: #6a6a6a;font-weight: bold;}
</style>



// WEBPACK FOOTER //
// src/components/cedu/about/ttitle.vue